import React from "react";
import ReactPlayer from "react-player";

const HomeSplayer = ({ url }) => {
  return (
    <div className="flex-grow">
      <div className="relative pt-[56.25%]">
        <ReactPlayer
          className="absolute top-0 left-0"
          url={url}
          width="100%"
          height="100%"
          controls={true}
        />
      </div>
    </div>
  );
};

export default HomeSplayer;
